import { merge } from '../../helper';

import removeClass from '../../general/class/removeClass';

import * as exTab from './utils';
import * as exType from './types';

// ----------------------------------------------------------------------------

export type TypeElements = HTMLElement | HTMLElement[];

export type TypeGeneralConfig = {
    validation?: Record<string, string>;
};

// ----------------------------------------------------------------------------

function general(elements: TypeElements, config?: TypeGeneralConfig): void {
    target(elements);
    validation(elements, config?.validation);
}

// ----------------------------------------------------------------------------

function target(elements: TypeElements): void {
    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        // If using dataset target
        const dataTarget = element.dataset.target ?? 1;

        // Get element (link)
        const elLink = element.querySelector<HTMLElement>('li:nth-child(' + dataTarget + ') > a:first-child');
        // If there is element (link)
        if (elLink) {
            exTab.show(elLink);
        }
    }
}

function validation(elements: TypeElements, config?: Record<string, any>): void {
    // Default Config
    const defConfig: Record<string, any> = {
        className: exType.color,
        selector: '.nav-link',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    if (!Array.isArray(elements)) {
        elements = [elements];
    }

    for (const element of elements) {
        const listNavLink = element.querySelectorAll<HTMLElement>(defConfig.selector);

        for (const elNavLink of listNavLink) {
            removeClass(elNavLink, defConfig.className);
        }
    }
}

// ----------------------------------------------------------------------------

export { general, target, validation };
